import React from 'react';

const AdminPagination = ({ page, pages, total, pageSize = 20, onPageChange }) => (
  <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-sm text-gray-600 bg-white border border-gray-200 rounded-xl">
    <span>
      {total === 0 ? 'No results' : `Showing ${(page - 1) * pageSize + 1}–${Math.min(page * pageSize, total)} of ${total}`}
    </span>
    <div className="flex items-center gap-2">
      <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1}
        className="px-3 py-1.5 rounded-lg border border-gray-200 disabled:opacity-40 hover:bg-gray-50">Previous</button>
      <span>Page {page} of {Math.max(pages, 1)}</span>
      <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= pages}
        className="px-3 py-1.5 rounded-lg border border-gray-200 disabled:opacity-40 hover:bg-gray-50">Next</button>
    </div>
  </div>
);

export default AdminPagination;
